import type { GeojsonEditorProps } from "./geojson-editor.type";
import type { OnMount } from "@monaco-editor/react";

import { useTranslation } from "react-i18next";

import { stringify } from "@/utilities/json";

import { THEME_LIGHT } from "./geojson-editor.constant";
import { parseGeojson } from "./geojson-editor.helper";

export const useGeoJsonEditor = ({
  value,
  onError,
  onChange,
}: GeojsonEditorProps) => {
  const { t } = useTranslation();
  const geoJson = stringify(value);

  const handleChange = (val: string | undefined) => {
    onError(null);

    const { value, error } = parseGeojson(val);

    if (error) {
      onError(t("global:geojson.clientError"));
    } else {
      onChange?.(value);
    }
  };

  const handleEditorDidMount: OnMount = (_editor, monaco) => {
    monaco.languages.json.jsonDefaults.setDiagnosticsOptions({
      validate: true,
      allowComments: false,
      schemas: [],
    });

    monaco.editor.defineTheme(THEME_LIGHT, {
      base: "vs",
      inherit: true,
      rules: [],
      colors: {
        "editor.background": "#f8f8f8",
      },
    });

    monaco.editor.setTheme(THEME_LIGHT);
  };

  return { geoJson, handleChange, handleEditorDidMount };
};
